import validatorjs from 'validatorjs';

function GeneralStepEditForm() {
	let validator = validatorjs;

	validator.register(
		'numericMinValue',
		value => {
			return 1 / value > 0;
		},
		'NUMERICMINVALUE'
	);
	validator.register(
		'notZero',
		value => {
			return value != 0;
		},
		'NOTZEROVALUE'
	);
	validator.register(
		'notDecimal',
		value => {
			return !value.toString().includes('.');
		},
		'NOTDECIMALVALUE'
	);

	return {
		fields: [
			'generalStep.seller',
			'generalStep.mainSku',
			'generalStep.onePerBox',
			'generalStep.name',
			'generalStep.description',
			'generalStep.asin',
			'generalStep.productUpcs',
			'generalStep.productUpcs[].id',
			'generalStep.productUpcs[].upc',
			'generalStep.condition',
			'generalStep.productCategory',
			'generalStep.productStatus',
			'generalStep.isMultiPackage',
			'generalStep.productPartQuantity',
		],
		labels: {
			'generalStep.seller': 'PRODUCTVIEW.SELLER',
			'generalStep.mainSku': 'PRODUCTVIEW.PRODUCTSKU',
			'generalStep.onePerBox': 'PRODUCTVIEW.ONEPERBOX',
			'generalStep.name': 'PRODUCTVIEW.NAME',
			'generalStep.description': 'PRODUCTVIEW.DESCRIPTION',
			'generalStep.asin': 'PRODUCTVIEW.ASIN',
			'generalStep.productUpcs[].upc': 'PRODUCTVIEW.UPC',
			'generalStep.condition': 'PRODUCTVIEW.CONDITION',
			'generalStep.productCategory': 'PRODUCTVIEW.PRODUCTCATEGORY',
			'generalStep.productStatus': 'PRODUCTVIEW.PRODUCTSTATUS',
			'generalStep.isMultiPackage': 'PRODUCTVIEW.ISMULTIPACKAGE',
			'generalStep.productPartQuantity': 'PRODUCTVIEW.QUANTITY',
		},
		rules: {
			'generalStep.mainSku': 'required',
			'generalStep.name': 'required',
			'generalStep.upc': 'required',
			'generalStep.condition': 'required',
			'generalStep.productStatus': 'required',
			'generalStep.productUpcs[].upc': 'required',
		},
	};
}

export default GeneralStepEditForm;



// WEBPACK FOOTER //
// ./src/modules/product/wizard/forms/GeneralStepEditForm.js